import { render } from "./view.html?vue&type=template&id=1b73e9ad&ts=true"
import script from "./view.ts?vue&type=script&lang=ts"
export * from "./view.ts?vue&type=script&lang=ts"

import "./view.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__